export default __webpack_public_path__ + "static/media/auth-pattern-dark.df61463d.svg";